import { ActionType, createAsyncAction } from 'typesafe-actions'
import { Failure, Request, Success } from './types'
import { LabelState } from '../../types'

export const deleteLabelAction = createAsyncAction(
  '@label/DELETE_LABEL_REQUEST',
  '@label/DELETE_LABEL_SUCCESS',
  '@label/DELETE_LABEL_FAILURE'
)<Request, Success, Failure>()

const request = (state: LabelState, action: ActionType<typeof deleteLabelAction.request>): LabelState => ({
  ...state,
  isLoadingDeleteLabel: true
})

const success = (state: LabelState, action: ActionType<typeof deleteLabelAction.success>): LabelState => {
  const labelIdToDelete = action.payload?.labelId
  return {
    ...state,
    labels: state?.labels?.filter(label => label.id !== labelIdToDelete),
    isLoadingDeleteLabel: false,
    isSuccessOnDeleteLabel: true
  }
}
const failure = (state: LabelState, action: ActionType<typeof deleteLabelAction.failure>): LabelState => ({
  ...state,
  isLoadingDeleteLabel: false,
  isErrorOnDeleteLabel: true
})

export const deleteLabelHandle = { asyncAction: deleteLabelAction, request, success, failure }
